import React, { Fragment, useEffect, useState } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Tooltip } from "@material-ui/core/";
import Paper from "@material-ui/core/Paper";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from "@material-ui/core/IconButton";
import withStyles from "@material-ui/core/styles/withStyles";
import RolesList from "./RolesList";
import { Typography } from "@material-ui/core";
import ModalPrompt from "./ModalPrompt";
import { ACCESS } from "../../../data";
import { useTranslation } from 'react-i18next';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  modal: {
    width: '400px'
  }
});

const UserTable = ({ users, access, removeUser, setUserRole, currentUser }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [delUserId, setDelUserId] = useState(null);
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    setUserList(users);
  }, [users]);
  const handleClose = () => setOpenDialog(false);
  const handleDeleteUser = () => {
    setOpenDialog(false);
    removeUser(delUserId);
    setUserList(userList.filter(user => user.id !== delUserId));
  };
  function handleOpen(id) {
    setOpenDialog(true);
    setDelUserId(id);
  }

  return (
    <Fragment>
      {userList && userList.length ? <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="user permissions table">
          <TableHead>
            <TableRow>
              <StyledTableCell>{t("fullName")}</StyledTableCell>
              <StyledTableCell>{t("userEmail")}</StyledTableCell>
              <StyledTableCell>{t("access")}</StyledTableCell>
              <StyledTableCell>{t("delete")}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userList.map((row) => (
              <StyledTableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.email}
                </TableCell>
                <TableCell>
                  <RolesList id={row.id} access={row.access} disabled={currentUser === row.email || access === ACCESS.READ_ONLY} setUserRole={setUserRole} />
                </TableCell>
                <TableCell>
                  <Tooltip title={t("delete")+ " " + row.email} placement="right">
                    <IconButton disabled={currentUser === row.email || access === ACCESS.READ_ONLY} onClick={() => handleOpen(row.id)}><DeleteIcon /></IconButton>
                  </Tooltip>
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> : <Typography variant="subtitle1" component="h4">{t("selectBranchOrSite")}</Typography>}
      {openDialog && <ModalPrompt title={t("deleteUser")}
        content={t("areYouSure")}
        action={t("delete")}
        handleAction={handleDeleteUser}
        handleCancel={handleClose}
        openModal={openDialog} />}
    </Fragment>
  );
};

export default UserTable;
